export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ae25198e-cb74-4fc2-a321-95c6330ede0c';
export const MODAL_CLOSE_SEC = 2.5;
